import React, { useEffect, useState } from 'react'
import { Box, Text } from "grommet"
import AgDataTable from '../../common/AgDataTable'
import Spinner from '../../common/Spinner'
import { useConnection } from '../../../utils/connection'
import { HealthServiceDataViewStatus } from './HealthStatusService'
import envConfig from '../../../utils/envConfig'
import { deepClone } from '../../../utils/clone'


const HealthStatusServiceBookie = ({ data, env }) => {

    const connectionLookup = useConnection(env)
    const liteMode = envConfig[process.env.REACT_APP_ENVIRONMENT]['lite']

    //console.log(data)

    const tab_col = [
        {
            field: "id",
            headerName: "Connection ID",
            minWidth: 150,
            suppressSizeToFit: true,
        },
        {
            field: "connectionName",
            headerName: "Connection",
            minWidth: 200,

        },
        {
            field: "exchangeId",
            headerName: "Exchange ID",
            minWidth: 150,
            suppressSizeToFit: true,
        },
        {
            field: "status",
            headerName: "Status",
            minWidth: 200,
            suppressSizeToFit: true,
            cellStyle: function (params) {
                if (params.value !== 'up') {
                    return { color: 'white', backgroundColor: '#B4130B' };
                } else {
                    return { color: 'black', backgroundColor: 'white' };
                }
            }
        },
    ]

    const [tab_data, settab_data] = useState([])

    useEffect(() => {
        if (connectionLookup) {
            const tab_data_temp = Object.keys(data).sort((a, b) => (data[a].status === 'up') ? 1 : -1).reduce((rowData, rowId) => {

                const row = deepClone(data[rowId])
                const connectionName = row.id && connectionLookup[row.id] ? connectionLookup[row.id].name : '-'
                const exchangeId = row.id && connectionLookup[row.id] ? connectionLookup[row.id].exchangeId : '-'
                const tabs = [
                    {
                        'type': 'json',
                        'subheader': 'Bookie Connection',
                        'content': connectionLookup[row.id],
                    },
                    {
                        'type': 'session_history',
                        'subheader': 'History',
                        'content': {
                            'sessionId': row.id,
                            'sessionType': "connections",
                            'env': env
                        },
                    },
                ]

                //console.log(row)
                if (connectionLookup[row.id]) {

                    rowData.push({
                        'uniqueId': row.id,
                        'id': row.id,
                        'connectionName': connectionName,
                        'exchangeId': exchangeId,
                        'status': row.status,
                        'detailView': {
                            'head': {
                            },
                            'data': tabs
                        },
                    })

                }

                return rowData
            }, [])

            if (tab_data_temp && tab_data_temp.length > 0) {
                settab_data(tab_data_temp)
            }

        }
    }, [connectionLookup, data, env, liteMode])

    return (
        <Box border="top" margin={{ top: "small", left: "xsmall", right: "xsmall" }} fill="horizontal">

            <Box direction="row">
                <Text margin={{ top: "8px", bottom: "8px" }} size="small" color="dark-3" weight="bold"> Connections </Text>
                <HealthServiceDataViewStatus tab_data={tab_data.map(function (item) { return item["status"] })} />
            </Box>

            {!connectionLookup
                ? <Spinner />
                :
                <AgDataTable
                    tab_col={tab_col}
                    tab_data={tab_data}
                    tableName="HealthStatusServiceBookie"
                    defaultSubTab="Bookie Connection"
                    countTitle="Bookie Connections"
                    tableHeight={700}
                />
            }
        </Box>
    )
}

export default HealthStatusServiceBookie
